import React from 'react';

import { useLinkComponent } from '~/hooks/mobileApp';

import styles from './index.module.css';

function AddCartTooltip() {
  const LinkComponent = useLinkComponent();

  return (
    <LinkComponent href="/cart">
      <div className={styles.wrapper}>
        <div className={styles.title}>
          장바구니에서
          <br />
          구매를 완료해주세요.
        </div>
        <div className={styles.button} role="presentation">
          주문하기
        </div>
      </div>
    </LinkComponent>
  );
}

export default AddCartTooltip;
